
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Button, CircularProgress } from '@mui/material';
import axiosInstance from '../../api/axiosInstance';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderRadius: "4px",
    boxShadow: 24,
    p: 4,
    textAlign: "center"
};
const ExpireDateModal = ({ setOpen, cid, serial, current, setToEditRow, bussinessId, getData,setOpenSnackBar,setSnackbarMsgType }) => {

    const handleClose = () => {
        setToEditRow(null)
        setOpen(false)
    }


    const [helpDeskExpire, setHelpDeskExpire] = useState("")

    // const getHelpDeskTime = async () =>{
    //     let data = new FormData()
    //     data.append('pronar', cid);   
    //     data.append('serial', serial);
    //     const config = {     
    //         headers: { 'content-type': 'multipart/form-data' }
    //     }
    //     const url ="https://www.softexpres.com/helpdesk/getAssistenceDate.php"
    //     try{
    //         const res = await axios.post(url,data,config)
    //         setHelpDeskExpire(res.data?.Message);
    //     }catch(err){
    //         console.log(err)
    //     }

    // }

    const [currentExpire, setCurrentExpire] = useState("")
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (current) {
            setCurrentExpire(current)
        }
        // getHelpDeskTime()
    }, [])



    const updateExpireDate = async () => {

        setLoading(true)
        try {
            await axiosInstance.put(`/Business/id/${bussinessId}/expire/${currentExpire}`)
            setToEditRow(null)
            getData()
            setOpen(false)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "Business Updated Successfully",
                type: "success"
            })
        } catch (err) {
            console.log(err)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "Cant update the business",
                type: "error"
            })
        } finally {
            setLoading(false)
        }

    }


    return (
        <div>
            <Modal
                open={true}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography sx={{ mb: 2 }} id="modal-modal-title" variant="h6" component="h2">
                        Expire Date For {cid}
                    </Typography>

                    <Box>
                        {/* <Typography>Helpdesk expire date : {helpDeskExpire}</Typography> */}
                        {
                            currentExpire && currentExpire != "" ?
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker sx={{ width: "100%" }} value={dayjs(currentExpire)} onChange={(newValue) => setCurrentExpire(newValue)} />

                                </LocalizationProvider> : ""
                        }

                    </Box>
                    <Button sx={{ mt: 2 }} color='info' variant='contained' onClick={() => {
                        updateExpireDate()
                    }}>
                        {
                            loading ? <CircularProgress /> : "SAVE"
                        }
                    </Button>
                </Box>
            </Modal>
        </div>
    )
}


export default ExpireDateModal